import {ColumnType} from '../IEnhancedDetailsList';
import {EnhancedColumn} from './EnhancedColumn';
import {IColumn, IComboBoxOption} from '@fluentui/react';
import {PeoplePicker} from '../../PeoplePicker';
import {SelectPicker} from '../../SelectPicker';
import {UserDto} from '../../../../services/generated';

export class UserDtoColumn extends EnhancedColumn {
  public static type = ColumnType.UserDto;

  public static renderer(value: string | string[], column: IColumn): JSX.Element {
    if (Array.isArray(value)) {
      const users = value as any as UserDto[];
      const usersIds = users.map(user => user.azureId);
      return users.length ? (
        <div className="multipleOwners">
          <PeoplePicker
            onSelectPerson={null as any}
            defaultSelectedPersonIds={usersIds}
            isReadonly
          />
        </div>
      ) : (
        <></>
      );
    }
    const user: UserDto = value as any;
    return user ? (
      <PeoplePicker
        onSelectPerson={null as any}
        defaultSelectedPersonId={user.azureId}
        isReadonly
      />
    ) : (
      <></>
    );
  }

  public static getColumnValueForSort(value: UserDto | UserDto[]): string {
    if (Array.isArray(value)) {
      const users = value as any as UserDto[];
      return users.length ? users.map(user => user.userPrincipalName).join(', ') : '0';
    }
    return value?.userPrincipalName || '0';
  }

  public static hasActiveFilter(value: any): boolean {
    return value && value.length > 0;
  }

  public static renderFilter(
    defaultValue: any,
    onChange: (value?: string | string[] | undefined, options?: IComboBoxOption[]) => void,
    allOptions: UserDto[] | UserDto[][]
  ): JSX.Element {
    const flatOptions: UserDto[] = Array.isArray(allOptions[0])
      ? (allOptions as UserDto[][]).flat()
      : (allOptions as UserDto[]);
    const options = [...new Set(flatOptions.map(option => option?.userPrincipalName || ''))];
    return (
      <SelectPicker
        type="combobox"
        multiSelect
        label="Filter"
        defaultValue={defaultValue}
        options={options}
        onChange={(keys, items) => onChange(keys, items)}
      />
    );
  }

  public static filterFunction(itemValue: UserDto | UserDto[], filterValue: string[]): boolean {
    if (!Array.isArray(filterValue)) return false;
    return filterValue.some(filterVal => {
      if (!filterVal) return !itemValue;
      if (Array.isArray(itemValue)) {
        return itemValue.some(user => (user?.userPrincipalName || '').indexOf(filterVal) !== -1);
      }
      return (itemValue?.userPrincipalName || '').indexOf(filterVal) !== -1;
    });
  }

  public static searchFunction(itemValue: UserDto | UserDto[], lowerCaseSearch: string): boolean {
    if (Array.isArray(itemValue)) {
      return itemValue.some(user =>
        (user?.userPrincipalName || '').toLowerCase().includes(lowerCaseSearch)
      );
    }
    const email = itemValue?.userPrincipalName || '';
    return email ? email.toLowerCase().includes(lowerCaseSearch) : false;
  }

  public static getColumnValueForExcel(itemValue: UserDto | UserDto[]): string {
    if (Array.isArray(itemValue)) {
      const users = itemValue as any as UserDto[];
      return users.map(user => user.userPrincipalName).join(', ');
    }
    return itemValue?.userPrincipalName || '';
  }
}
